

import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Login from './pages/Login';
import Register from "./pages/Register"
import PasswordReset from "./pages/PasswordReset"
import AssignUserDashboard from "./pages/AssignUserDashboard";
import EventDetails from './pages/EventDetails';
import QRCodeVerification from './pages/QRCodeVerification';
import DashBoard from './pages/DashBoard';
import WelcomePage from './pages/WelcomePage';
import GuestPhotoUpload from './pages/GuestPhotoUpload/GuestPhotoUpload';
import AccessVideo from './pages/AccessVideo';

const App = () => {
  return (
    <Router>
      <div>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/passwordReset" element={<PasswordReset />} />
          {/* <Route path="/event-dashboard" element={<CreateEventForm />} /> */}
          <Route path="/assigneduserdashboard" element={<AssignUserDashboard />} />
          <Route path="/eventdetails" element={<EventDetails />} />
          <Route path="/QRCodeverification" element={<QRCodeVerification/>}/>
          <Route path="/DashBoard" element={<DashBoard/>}/>
          <Route path="/WelcomePage" element={<WelcomePage/>}/>
          <Route path="/upload-photos/:token" element={<GuestPhotoUpload />} />
          <Route path="/access-video/:shareId" element={<AccessVideo />} />
        </Routes>
      </div>
    </Router>
  );
};

export default App;